import React from 'react';

const Order = ({ match }) => <div>Order {match.params.orderId}</div>;

export default Order;


// WEBPACK FOOTER //
// ./src/components/Order.js